<template>
  <div>
    <div :class="`form-check-${placement} form-switch`">
      <input
        :class="`form-check-input ${placement !== 'right' ? 'me' : 'ms'}-2`"
        type="checkbox"
        :disabled="disabled"
        :checked="value"
        @input="$emit('input', $event.target.checked)"
        @change="handleChange"
      />
      <label v-if="label"> {{ label }} </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: false },
    placement: { type: String, required: false, default: 'right' },
    disabled: { type: Boolean, default: false },
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      checked: this.value,
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.checked)
    },
  },
}
</script>
